import { createRoot } from "react-dom/client";
import { prepareDesignEditor } from "@canva/intents/design";
import { AppUiProvider } from "@canva/app-ui-kit";
import { App } from "./app";
import "@canva/app-ui-kit/styles.css";
// Register the Data Connector intent alongside the Design Editor panel —
// Canva picks which handler to invoke based on how the app was opened.
import "./data-connector";

prepareDesignEditor({
  render: async () => {
    let container = document.getElementById("root");
    if (!container) {
      container = document.createElement("div");
      container.id = "root";
      document.body.appendChild(container);
    }
    const root = createRoot(container);
    root.render(
      <AppUiProvider>
        <App />
      </AppUiProvider>
    );
  },
});
